/**
 * Rotates an image by 90 degrees clockwise.
 *
 * @param {string} imageSource - The base64 string or URL of the image.
 * @returns {Promise<string>} - The rotated image as a base64 string.
 */
export async function rotateImage(imageSource) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Enable CORS for external URLs
    img.src = imageSource;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Swap dimensions for 90 degree rotation
      canvas.width = img.height;
      canvas.height = img.width;

      // Translate to center for rotation
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((90 * Math.PI) / 180);
      ctx.drawImage(img, -img.width / 2, -img.height / 2);

      // Get new base64 string (keep format as jpeg for consistency, or png)
      // Usually JPEGs are good for photos.
      // If original was PNG, we might lose transparency if we force JPEG.
      // But for photos in this app, JPEG is standard.
      const rotatedBase64 = canvas.toDataURL('image/jpeg', 0.9);
      resolve(rotatedBase64);
    };

    img.onerror = (err) => {
      reject(err);
    };
  });
}
